
<template>

    <div v-if="title == null">
      <PlaceholderContact
            icon='<svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 text-primary-500 mr-3 flex-shrink-0 mt-0.5" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="M8.625 12a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H8.25m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H12m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0h-.375M21 12c0 4.556-4.03 8.25-9 8.25a9.764 9.764 0 0 1-2.555-.337A5.972 5.972 0 0 1 5.41 20.97a5.969 5.969 0 0 1-.474-.065 4.48 4.48 0 0 0 .978-2.025c.09-.457-.133-.901-.467-1.226C3.93 16.178 3 14.189 3 12c0-4.556 4.03-8.25 9-8.25s9 3.694 9 8.25Z" /></svg>'
            title="W przypadku pytań prosimy o kontakt" subtitle=""
            avatar="/assets/df1f74cd-3988-4e4f-b99e-6e96a4f95ffb.png?width=40&height=40"
            contactInfo="<a href='tel:+48781728231'>+48 781 728 231</a>" contactName="Artur Jóskowiak" />
    </div>
    <div v-else class="self-stretch p-4 bg-Primary-50 inline-flex flex-col justify-start items-start gap-4">
        <div class="self-stretch flex flex-col justify-start items-start">
            <div class="self-stretch justify-start text-Neutral-900 text-2xl font-semibold font-['Montserrat'] leading-9">
                {{ title }}
            </div>
            <div class="self-stretch justify-start text-Neutral-900 text-sm font-normal font-['Montserrat'] leading-normal">
                {{ subtitle }}
            </div>
        </div>
        <div class="self-stretch inline-flex justify-start items-center gap-4">
            <img class="w-16 h-16 p-2 rounded-full" :src="avatar" />
            <div class="w-48 inline-flex flex-col justify-start items-start">
                <div class="self-stretch justify-center text-Neutral-900 text-xl font-semibold font-['Montserrat'] leading-loose">
                    {{ phone }}
                </div>
                <div class="self-stretch justify-center text-Neutral-900 text-base font-normal font-['Montserrat'] leading-normal">
                    {{ name }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Globals from '@shared/model/Globals.js';
export default {
    components: {
        Globals
    },
    name: "ContactBox",
    props: {
        title: {
            type: String,
            required: false,
            default: null,
        },
        subtitle: {
            type: String,
            required: false,
            default: null,
        },
        avatar: {
            type: String,
            required: false,
            default: null,
        },
        phone: {
            type: String,
            required: false,
            default: null,
        },
        name: {
            type: String,
            required: false,
            default: null,
        },
    },
};
</script>